export const beneficiaries = [
	'University College Hospital, Oyo',
	'School of Science, Osun',
	'Bodija International School, Oyo',
	'Lagos State Senior Model College, Lagos',
	'Ado Grammar School, Ekiti',
	'Little Saints Orphanage, Lagos',
	'Lagos State Teaching Hospital, Lagos',
	'Baptist High School, Ondo',
	'Dugbe Market, Oyo',
	'Akui Primary Health Centre, Osun',
	'Lagos University Teaching Hospital, Lagos',
	'International School, University of Ibadan, Oyo',
	'Kole Best School, Lagos',
	'Seventh Day Adventist, Osun',
	'Rem Yem Hospital, Lagos',
	'Living Springs, Oyo',
	'Alamo Grammar School, Ondo',
	'Ayo Specialist Hospital, Ondo',
	'Davister School, Lagos',
	'St Dominic School Ondo',
	'Kole Best School, Lagos',
	'Life and Peace Development, Ondo',
	'Enuwa Primary Health Centre, Osun',
	'Sabo Ola-Olu Primary Health Centre, Osun',
	'Abagboro Primary Health Centre, Osun',
	'Ajebamidele MDGs Health Centre, Ondo',
	'Ojatuntun Primary Health Centre, Osun',
	'Oba Aderemi Primary Health Centre, Osun',
	'Gbalefefe Primary Health Centre, Osun',
	'Iredapo Health Care Center, Osun',
	'Modakeke High School, Osun',
	'STMA Group of Schools, Osun',
	'Excel Intervention Schools, Osun',
	'Best Foundation, Osun',
	'Victory Immaculate School, Osun',
	'Paincare Outreach, Lagos',
	'Adekunle Adegunle Global Foundation, Lagos',
	"House of Mercy Children's Home, Lagos",
	'Compassionate Orphanage, Lagos',
];

export const beneficiarySummary = [
	{
		category: 'Schools',
		total: 334,
		description:
			'Over 220,000 students and teachers in predominantly public schools and universities in remote areas across the south-west were major beneficiaries of the project’s masks and face shields.',
		image: '/assets/images/schoolss.jpeg',
	},
	{
		category: 'Hospitals',
		total: 1076,
		description:
			'More than 60,000 health workers in primary, secondary and tertiary healthcare centres received PPE to support their frontline efforts, and for their use beyond the pandemic.',
		image: '/assets/images/hospitals.jpeg',
	},
	{
		category: 'NGOs',
		total: 158,
		description:
			'Over 270,000 beneficiaries of various health and welfare causes across the country received medical and non-medical protective equipment during outreaches and state-wide distributions.',
		image: '/assets/images/ngos.jpeg',
	},
	{
		category: 'Markets',
		total: 37,
		description: 'The markets also benefited from direct sensitisation efforts through in-person sessions by our team.',
	},
	{
		category: 'Transport Workers',
		total: 2000,
		description:
			'Associations of transport workers encouraged public PPE use by requiring their passengers to adhere to precautions.',
	},
	{
		category: 'Other Institutions',
		total: 41,
		description:
			'Religious institutions and small businesses did their part to protect their congregations, staff and customers respectively.',
	},
];
